import styles from './toggle-button-group.module.scss';
import MaterialToggleButtonGroup from '@mui/material/ToggleButtonGroup';

/* eslint-disable-next-line */
export interface ToggleButtonGroupProps {
  children: any,
  // classes?: object,
  color?: 'standard' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  disabled?: boolean,
  exclusive?: boolean,
  fullWidth?: boolean,
  onChange?: (event: any, value: any) => void,
  orientation?: 'horizontal' | 'vertical',
  size?: 'small' | 'medium' | 'large',
  sx?: any,
  value?: any,
  className?: string
}

export function ToggleButtonGroup(props: ToggleButtonGroupProps) {
  return (
    <MaterialToggleButtonGroup
      exclusive={props.exclusive}
      disabled={props.disabled}
      color={props.color}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      className={props.className}
      fullWidth={props.fullWidth}
      orientation={props.orientation}
      sx={props.sx}>
      {props.children}
    </MaterialToggleButtonGroup>
  );
}

export default ToggleButtonGroup;